import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import type { CampaignInfluencer } from "../types";

interface EditInfluencerDetailsDialogProps {
  isOpen: boolean;
  influencer: CampaignInfluencer | null;
  deliverables: string;
  onDeliverablesChange: (value: string) => void;
  fee: number | "";
  onFeeChange: (value: number | "") => void;
  onClose: () => void;
  onSave: (e: React.FormEvent) => void;
  isPending: boolean;
}

export const EditInfluencerDetailsDialog: React.FC<EditInfluencerDetailsDialogProps> = ({
  isOpen,
  influencer,
  deliverables,
  onDeliverablesChange,
  fee,
  onFeeChange,
  onClose,
  onSave,
  isPending,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-[425px]">
        <form onSubmit={onSave}>
          <DialogHeader>
            <DialogTitle>Edit Influencer Details</DialogTitle>
            <DialogDescription>
              Update the deliverables and fees for {influencer?.name}.
            </DialogDescription>
          </DialogHeader>
          <div className="grid gap-4 py-4">
            <div className="grid grid-cols-4 items-center gap-4">
              <Label htmlFor="deliverables" className="text-right font-medium">
                Deliverables
              </Label>
              <Input
                id="deliverables"
                value={deliverables}
                onChange={(e) => onDeliverablesChange(e.target.value)}
                placeholder="e.g. 1 Reel, 2 Stories"
                className="col-span-3 border-slate-200"
              />
            </div>
            <div className="grid grid-cols-4 items-center gap-4">
              <Label htmlFor="fee" className="text-right font-medium">
                Fees
              </Label>
              <Input
                id="fee"
                type="number"
                value={fee}
                onChange={(e) =>
                  onFeeChange(
                    e.target.value === "" ? "" : Number(e.target.value)
                  )
                }
                placeholder="Committed fee amount"
                className="col-span-3 border-slate-200"
              />
            </div>
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={onClose}>
              Cancel
            </Button>
            <Button
              type="submit"
              className="bg-[#A655F8] text-white hover:bg-[#923de6]"
              disabled={isPending}
            >
              {isPending ? "Saving..." : "Save Changes"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
